import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined';
import LiveHelpOutlinedIcon from '@material-ui/icons/LiveHelpOutlined';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import BlockIcon from '@material-ui/icons/Block';
import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined';
import SubscriptionsOutlinedIcon from '@material-ui/icons/SubscriptionsOutlined';
import DeviceSwitcher from 'components/devices/DeviceSwitcher';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import useConferenceWrapperStyles from './ConferenceWrapper.styles';
import ClassroomChat from './sidebar-components/chat/Chat';
import Questions from './sidebar-components/questions/index';
import Roster from './sidebar-components/roster/Roster';
import BanList from './sidebar-components/ban-list/BanList';
import Help from './sidebar-components/help';
import SidePanelBranding from './sidebar-components/SidePanelBranding';
import SidePanelTitle from './sidebar-components/SidePanelTitle';
import StreamController from './sidebar-components/stream-controls/StreamController';
import ChatIcon from './sidebar-icons/ChatIcon';
import DefaultIcon from './sidebar-icons/DefaultIcon';
import PresenterDevices from './sidebar-icons/PresenterDevices';
import StartStream from './sidebar-icons/StartStream';
import StopStream from './sidebar-icons/StopStream';
import StreamStatus from './sidebar-icons/StreamStatus';

const ConferenceStyleWrapper = ({ children }) => {
  const classes = useConferenceWrapperStyles();
  const { popout, role, Status } = useSelector(({ classroom, user, conference }) => ({
    popout: classroom.popout,
    role: user.role,
    Status: conference.Status,
  }));
  let isPresenter = role === 'presenter';
  let showSidebar = isPresenter || role === 'admin' || Status === 'LIVE';
  return (
    <>
      <Box className={classes.root}>
        <div className={classes.videoSection}>{children}</div>
        {popout.open && (
          <div className={classes.sidePanel}>
            <SidePanelTitle>{popout.name}</SidePanelTitle>
            <SidePanelBranding />
            <div className={classes.sidePanelContent}>
              {popout.name === 'Participants' && <Roster />}
              {popout.name === 'Group Chat' && <ClassroomChat />}
              {popout.name === 'Question & Answer' && <Questions />}
              {popout.name === 'Session Studio' && <StreamController />}
              {popout.name === 'Blocked Users' && <BanList />}
              {popout.name === 'Devices' && <DeviceSwitcher />}
              {popout.name === 'Help Request' && <Help />}
            </div>
          </div>
        )}
        {showSidebar && (
          <div className={classes.sideMenu}>
            <div>
              <List style={{ padding: 0 }} className={classes.icnListClassName}>
                <DefaultIcon name="Question & Answer" IconComp={LiveHelpOutlinedIcon} />
                {isPresenter && <ChatIcon name="Group Chat" />}
                {isPresenter && <DefaultIcon name="Participants" IconComp={GroupOutlinedIcon} />}
                {isPresenter && (
                  <DefaultIcon name="Session Studio" IconComp={SubscriptionsOutlinedIcon} />
                )}
                {isPresenter && <DefaultIcon name="Blocked Users" IconComp={BlockIcon} />}
                {isPresenter && <DefaultIcon name="Devices" IconComp={MoreIcon} />}
                {isPresenter && (
                  <DefaultIcon name="Help Request" IconComp={ContactSupportOutlinedIcon} />
                )}
              </List>
            </div>
            {isPresenter ? (
              <>
                <PresenterDevices /> <StreamStatus />
                <div>
                  <List style={{ padding: 0 }} className={classes.bottomIconList}>
                    <StartStream />
                    <StopStream />
                  </List>
                </div>
              </>
            ) : (
              <div className={classes.attendeeStatusBox}>
                <StreamStatus />
              </div>
            )}
          </div>
        )}
      </Box>
    </>
  );
};

ConferenceStyleWrapper.propTypes = {
  children: PropTypes.node,
};
export default ConferenceStyleWrapper;
